export enum NOTIFICATION {
  CLOSE_BTN = "notificationCloseBtn",
  NO_RESULTS_MY_CLEANINGS = "notificationMyCleaningsNoResults",
}
